var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[_c('h3',[_vm._v("Blockchain Transactions")]),_c('v-data-table',{attrs:{"title":"Blockchain Transactions","items":_vm.transaction.block_chain,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }